var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadCentral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667,4H25.333C26.041,4 26.719,4.281 27.219,4.781C27.719,5.281 28,5.959 28,6.667V25.333C28,26.813 26.813,28 25.333,28H6.667C5.959,28 5.281,27.719 4.781,27.219C4.281,26.719 4,26.041 4,25.333V6.667C4,5.2 5.2,4 6.667,4ZM10.667,22.667H21.333V20H10.667V22.667ZM21.333,13.333H18V9.333H14V13.333H10.667L16,18.667L21.333,13.333Z",
    fill: "#BD7EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCentral);
export default __webpack_public_path__ + "static/media/downloadCentral.1aa935fb2fcef23eab68783006470e3a.svg";
export { ForwardRef as ReactComponent };